import type { ExamTypeDTO } from '@/features/services/api';
import { QuickTapButton } from './QuickTapButton';

interface QuickTapGridProps {
  examTypes: ExamTypeDTO[];
  counters: Record<string, number>;
  onTap: (examTypeId: string) => void;
  onRemove?: (examTypeId: string) => void;
  disabled?: boolean;
}

export function QuickTapGrid({ examTypes, counters, onTap, onRemove, disabled }: QuickTapGridProps) {
  if (examTypes.length === 0) {
    return (
      <p className="rounded-md border border-dashed border-(--color-border) p-4 text-center text-sm text-(--color-fg-muted)">
        Nenhum procedimento cadastrado neste serviço. Cadastre em Serviços antes de iniciar.
      </p>
    );
  }
  return (
    <div
      className="grid gap-2"
      style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))' }}
    >
      {examTypes.map((e) => (
        <QuickTapButton
          key={e.id}
          examTypeId={e.id}
          shortName={e.shortName}
          fullName={e.name}
          unitValue={e.value}
          count={counters[e.id] ?? 0}
          onTap={onTap}
          onRemove={onRemove}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
